import { render } from "./Welcome.vue?vue&type=template&id=19128fd9&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=19128fd9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19128fd9"

export default script